import { render, staticRenderFns } from "./AccountTransactionsTable.vue?vue&type=template&id=506513c6&scoped=true"
import script from "./AccountTransactionsTable.vue?vue&type=script&lang=js"
export * from "./AccountTransactionsTable.vue?vue&type=script&lang=js"
import style0 from "./AccountTransactionsTable.vue?vue&type=style&index=0&id=506513c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506513c6",
  null
  
)

export default component.exports